module.exports = __webpack_public_path__ + "media/images/mypage/mypage_btm-26cac851d5a746ac7fca5bd734516432.gif";